<template>
  <div
    class="list-view d-flex flex-column flex-grow-1"
    style="background-color: white; position: relative;"
  >
    <BackTop></BackTop>
    <div v-if="listStyle === 'inline'" class="d-flex flex-grow-1 flex-column">
      <v-list three-line flat class="py-0" id="listItems" ref="listItems">
        <v-list-item-group>
          <v-list-item
            v-for="(item, index) in contentBriefs.crystalItemVos"
            @click="toDetail(item.id)"
            style="border-bottom: 1px solid #e8ebf0; height: 233px;"
          >
            <template v-slot:default :ref="'brief' + index">
              <v-list-item-action style="width: 232px; height: 205px;">
                <img
                  :src="item.data"
                  style="width: 200px; height: 200px;"
                  alt=""
                />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="pb-2">{{
                  item.title
                }}</v-list-item-title>
                <v-list-item-subtitle
                  >System: {{ item.system }}</v-list-item-subtitle
                >
                <v-list-item-subtitle
                  >a: {{ item.unitCell.a }}</v-list-item-subtitle
                >
                <v-list-item-subtitle
                  >b: {{ item.unitCell.b }}</v-list-item-subtitle
                >
                <v-list-item-subtitle
                  >c: {{ item.unitCell.c }}</v-list-item-subtitle
                >
                <v-list-item-subtitle
                  >α: {{ item.unitCell.alpha }}</v-list-item-subtitle
                >
                <v-list-item-subtitle
                  >β: {{ item.unitCell.beta }}</v-list-item-subtitle
                >
                <v-list-item-subtitle
                  >γ: {{ item.unitCell.gamma }}</v-list-item-subtitle
                >
              </v-list-item-content>
            </template>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
    <div v-if="listStyle === 'block'" class="d-flex flex-column flex-grow-1">
      <v-row justify="start" align="start" id="listItems" ref="listItems">
        <v-col
          v-for="(item, index) in contentBriefs.crystalItemVos"
          @click="toDetail(item.id)"
          :key="item.id"
          sm="6"
          md="4"
          class="all-center"
          style="cursor: pointer;"
        >
          <v-card
            style="width: 200px; height: 260px;"
            class="d-flex flex-column justify-space-between"
          >
            <img :src="item.data" alt="" />
            <div>
              <p
                class=""
                style="
                  text-align: center;
                  white-space: normal;
                  font-size: 18px;
                "
              >
                {{ item.title }}
              </p>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <v-progress-linear
      indeterminate
      background-color="#f9f9f9"
      color="#999 "
      v-if="isLoading"
      class="mt-4 mb-4"
    ></v-progress-linear>

    <div
      v-if="showSearchImg"
      style="
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      "
    >
      <div v-if="!noResults">
        <img
          src="../assets/searching.gif"
          style="width: 200px; height: 200px;"
          alt=""
        />
      </div>
      <div v-else>
        <img
          src="../assets/noResult.png"
          alt=""
          style="width: 200px; height: 200px;"
        />
        <div class="text-center">无搜索结果</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "CrystalList",
  data() {
    return {
      contentBriefs: {},
      scrollTop: "",
      currentPage: 1,
      flag: true,
      showSearchImg: true,
      noResults: false,
      isLoading: false,
    };
  },
  created() {
    let data = window.localStorage.getItem("crystalConditions");
    this.crystalSearch(JSON.parse(data))
      .then((res) => {
        if (res.data.code === 701 || res.data.code === 702) {
          this.noResults = true;
        } else {
          this.contentBriefs = this.briefs;
          this.showSearchImg = false;
        }
      })
      .catch(() => {
        setTimeout(() => {
          this.$router.push("/");
        }, 1000);
      });
  },
  mounted() {
    window.onscroll = () => {
      //文档内容实际高
      let scrollHeight = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight
      );
      //滚动条滚动距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //窗口可视范围高度
      let clientHeight =
        window.innerHeight ||
        Math.min(
          document.documentElement.clientHeight,
          document.body.clientHeight
        );

      if (clientHeight + scrollTop >= scrollHeight) {
        if (this.contentBriefs.total > this.currentPage * 12) {
          this.isLoading = true;
          this.crystalSearch({ type: "next", label: this.briefs.next }).then(
            () => {
              this.isLoading = false;
              this.contentBriefs.crystalItemVos = this.contentBriefs.crystalItemVos.concat(
                this.briefs.crystalItemVos
              );
              this.currentPage = this.currentPage + 1;
            }
          );
        }
      }
    };
  },
  computed: {
    ...mapState(["briefs", "listStyle"]),
  },
  methods: {
    ...mapMutations(["SET_LISTSTYLE"]),
    ...mapActions(["getDetail", "crystalSearch"]),
    toDetail(id) {
      window.open(`#/detail?id=${id}`);
    },
    changeStyle(status) {
      this.SET_LISTSTYLE(status);
    },
    getStructrue(data, format) {
      return { data, format };
    },
  },
  watch: {},
};
</script>

<style scoped></style>
